import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import TagManager from 'react-gtm-module';
import "./styles/tailwind.css";
import "./styles/index.css";

const tagManagerArgs = {
    gtmId: 'GTM-PW6S5H8T'
}

TagManager.initialize(tagManagerArgs);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);

